import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore'; // Importa 'onSnapshot' em vez de 'getDoc'
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../services/firebase';

export function useUserData() {
  const [user, loadingAuth] = useAuthState(auth); // user é o objeto do Firebase Auth
  const [userData, setUserData] = useState(null); // userData são os dados do Firestore
  const [loadingData, setLoadingData] = useState(true); // Controla o carregamento dos dados do Firestore

  useEffect(() => {
    let unsubscribeFirestore = () => {}; // Inicializa a função de unsubscribe

    if (user) {
      // Se há um usuário autenticado, escuta as mudanças em seu documento no Firestore
      const ref = doc(db, 'users', user.uid);
      unsubscribeFirestore = onSnapshot(
        ref,
        (snap) => {
          // Usa onSnapshot para real-time
          if (snap.exists()) {
            setUserData(snap.data());
          } else {
            console.warn(
              'Dados do usuário não encontrados no Firestore para UID:',
              user.uid
            );
            setUserData(null); // Define como null se não existirem dados
          }
          setLoadingData(false); // Define como false após a primeira carga (ou atualização)
        },
        (error) => {
          console.error('Erro ao escutar dados do usuário:', error);
          setUserData(null); // Em caso de erro, define como null
          setLoadingData(false); // Define como false em caso de erro
        }
      );
    } else {
      // Se não há usuário logado, limpa os dados e define loading como false
      setUserData(null);
      setLoadingData(false);
    }

    // Função de limpeza para desinscrever o listener do Firestore
    // Esta função será chamada quando o componente for desmontado ou quando as dependências do useEffect mudarem
    return () => unsubscribeFirestore();
  }, [user]); // Depende apenas de 'user' (o objeto do Firebase Auth)

  // O carregamento geral é true se a autenticação ainda está acontecendo OU os dados do usuário ainda estão sendo buscados
  return { user, userData, loading: loadingAuth || loadingData };
}
